import { Injectable } from '@angular/core';

/** A chart that can mirror a hovered x-index broadcast from a sibling chart. */
export interface SyncableChart {
  syncTooltipToIndex(index: number | null): void;
}

/**
 * Coordinates hover state across a group of `xemex-chart` instances so that hovering
 * one chart shows its tooltip/highlight at the same x-index on every other chart.
 *
 * All charts in a group share the same time axis, so an index identifies the same
 * interval everywhere. Provide this on a container component (e.g. the device
 * insights page) to scope the group to that view; charts with no ancestor provider
 * inject `null` and simply don't sync.
 */
@Injectable()
export class ChartSyncService {
  private readonly charts = new Set<SyncableChart>();

  register(chart: SyncableChart): void {
    this.charts.add(chart);
  }

  unregister(chart: SyncableChart): void {
    this.charts.delete(chart);
  }

  /** Mirror the hovered x-index from `source` onto every other chart in the group. */
  broadcast(source: SyncableChart, index: number | null): void {
    for (const chart of this.charts) {
      if (chart === source) continue;
      chart.syncTooltipToIndex(index);
    }
  }
}
